import { createSelector } from 'reselect';

import find from 'lodash/find';

import { getOpenedFiles } from 'store/utils/fileSystem';

const resourcesSelector = state => state.resources;

export const showSelector = createSelector(
  resourcesSelector,
  resources => resources.show,
);

export const getAllFiles = createSelector(
  resourcesSelector,
  resources => resources.all.data,
);

export const getFiles = ({ resources }) => resources.all.data;

export const getFilesMap = createSelector(
  getFiles,
  data =>
    data.reduce(
      (acc, item) => ({
        ...acc,
        [item.path]: item,
      }),
      {},
    ),
);

export const getSearchTerm = ({ resources }) => resources.all.searchTerm;

export const getIsLoading = ({ resources }) => resources.all.isLoading;

export const getIsUploading = ({ resources }) => resources.upload.isLoading;

export const getUploadingFiles = ({ resources }) => resources.upload.files;

export const getIsSaving = ({ resources }) => resources.show.isSaving;

export const getUploadingFilesWithError = createSelector(
  getUploadingFiles,
  files => files.filter(f => f.hasError === true),
);

export const getHasUploadingFilesError = createSelector(
  getUploadingFilesWithError,
  files => files.length !== 0,
);

export const getFilteredFiles = createSelector(
  getFiles,
  getSearchTerm,
  (files, searchTerm) =>
    files.filter(f => f.name.toLowerCase().includes(searchTerm.toLowerCase())),
);

export const getEditorFiles = createSelector(
  getFiles,
  all => getOpenedFiles(all),
);

export const getEditorCurrentFile = createSelector(
  showSelector,
  getAllFiles,
  (show, all) => find(all, { id: show.presentedId }) || {},
);

export const getEditorSearchTerm = ({ resources }) => resources.show.searchTerm;

export const getTheme = ({ resources }) => resources.show.theme;

export const getIsEditorLoading = ({ resources }) => resources.show.isLoading;
